import StateObserver from 'src/StateObserver';
import { TutorialStep } from 'src/replicant/tutorial/tutorial.ruleset';
import { TutorialEvent } from '../TutorialController';
import OrdinaryTutorial from './OrdinaryTutorial';
import * as Daycare from 'src/replicant/daycare';
import { showTutorial } from '../tutorial.util';

export class DaycareTutorial extends OrdinaryTutorial {
  public readonly step: TutorialStep = 'daycare';

  public async handleEvent(event: TutorialEvent): Promise<boolean> {
    if (event !== 'careMenuOpened') {
      return false;
    }

    // Ignore until daycare is unlocked
    const { user } = StateObserver.getState();
    const { isAvailable } = Daycare.getters.isAvailable(
      user,
      StateObserver.now(),
    );
    if (!isAvailable) return false;

    // Show tutorial popup and grant rewards
    await showTutorial('daycare', {
      $stepIndex: 18,
      $stepName: 'daycare',
    });

    return true;
  }
}
